import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import uiControll from '@/store/uiControll'
import getCsrfToken from '@/store/Csrf'
import { commonUtil } from '@/util'

const Actions = {
  // BP01 収支データ取得
  getBalanceOfPaymentListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const { currentMonth, lastMonth } = params
    // return await axios
    //   .get(apiMock.BALANCE_OF_PAYMENT_LIST)
    return await Promise.all([
      axios.get(api.BALANCE_OF_PAYMENT_LIST, { params: currentMonth }),
      axios.get(api.BALANCE_OF_PAYMENT_LIST, { params: lastMonth })
    ])
      .then((responses) => {
        const arr = [responses[0].data, responses[1].data]
        const path =
          mutationsTypes.BALANCE_OF_PAYMENT_SET_BALANCE_OF_PAYMENT_LIST
        commit(path, { balanceOfPaymentList: arr })
        const getData = getters.getBalanceOfPaymentListFromState
        const ret = commonUtil.afterApiSuccessProcess(responses, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
